<template>
	<v-card flat class="ma-0">
		<v-form ref="form">
			<h6 class="text-body-1 font-weight-bold mt-2">絞り込み</h6>
			<v-row no-gutters justify="center">
				<v-col cols="12" sm="6" lg="4" class="px-1">
					<v-text-field label="台帳番号" v-model="q.todo" class="mt-4" outlined clearable dense />
				</v-col>
				<v-col cols="12" sm="6" lg="4" class="px-1">
					<v-select
						label="担当者"
						v-model="q.todo"
						:items="users"
						item-text="full_name"
						item-value="id"
						class="mt-4"
						outlined
						clearable
						dense
					/>
				</v-col>
				<v-col cols="12" sm="6" lg="4" class="px-1">
					<v-text-field label="着工予定日" v-model="q.todo" class="mt-4" outlined clearable dense />
				</v-col>
				<v-col cols="12" sm="6" lg="4" class="px-1">
					<v-text-field label="受付日" v-model="q.todo" class="mt-4" outlined clearable dense />
				</v-col>
				<v-col cols="12" sm="6" lg="4" class="px-1">
					<v-checkbox class="mt-4 mr-2" label="完了済みも表示" v-model="q.todo" />
				</v-col>
				<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
					<v-row no-gutters>
						<v-col cols="6" class="pr-1">
							<v-btn width="100%" @click="searchOrderIndividualInfos" color="secondary">
								<v-icon class="mr-2">mdi-magnify</v-icon>
								検索</v-btn
							>
						</v-col>
						<v-col cols="6" class="pl-1">
							<v-btn width="100%" @click="resetForm" outlined color="secondary">
								<v-icon class="mr-2">mdi-autorenew</v-icon>
								クリア</v-btn
							>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-form>
	</v-card>
</template>

<script>

export default {
	props: {
		users: {
			type: Array,
			required: true,
		},
		text: {
			type: Boolean,
			default: false,
		},
		query: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			q: {
				todo: null,
			},
		}
	},
	mounted() {
		this.q = this.query
	},
	methods: {
		searchOrderIndividualInfos() {
			this.$emit("search-products", this.q)
			this.dialog = false
		},
		resetForm() {
			this.$refs.form.reset()
		},
	},
	watch: {
		query: {
			handler(val) {
				this.q = val
			},
			deep: true,
		},
	},
}
</script>